export function isOnAndroidDevice(){
    return /Android/i.test(navigator.userAgent);
};


export function isOnAppleDevice(){
    return /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent);
};


//Font size limits in px. The header uses a smaller range than the main content.
export const FONT_SIZE = {
    DEFAULT: 16,
    STEP: 2,
    MAIN_MIN: 10,
    MAIN_MAX: 48,
    HEADER_MIN: 14,
    HEADER_MAX: 22,
};


export function clampFontSize(value, min, max){
    return Math.min(Math.max(value, min), max);
};


//Converts a font size in px (as measured at the browser's default 16px) to rem,
//so the browser's own font size setting still scales the text.
export function pxToRem(px){
    return `${px / FONT_SIZE.DEFAULT}rem`;
};


//Below this width the header collapses to the mobile menu. Media queries resolve em
//against the browser's default font size, so the breakpoint follows browser zoom and
//the browser's font size setting.
export const MOBILE_LAYOUT_QUERY = "(max-width: 64em)";